
export default function useEmitter() {
    console.log()
    return window.emitter
}
